import { DEFAULT_FILL_OPACITY } from '../../../../core/constants.js';
import { ShapeColor } from '../../../../core/types/color-palette.js';
import { getOpacity } from '../../../../core/utils/getOpacity.js';
import { SeriesMetadata } from '../../../types/timeseries.js';

/**
 * Given a key, color token and colored timeseries, the bar color will be returned.
 *
 * @param key - Color key
 * @param color - Color token
 * @param highlightedSeriesId - The highlighted Colored Timeseries
 * @returns The Shape Color
 */
export const getBarStyle = (
  seriesMetadata: SeriesMetadata,
  highlightedSeriesId?: string[],
): ShapeColor => {
  if (!highlightedSeriesId) {
    return {
      color: seriesMetadata.color.Default,
      opacity: DEFAULT_FILL_OPACITY,
    };
  }

  const isCurrentHighlighted = highlightedSeriesId?.includes(seriesMetadata.id);

  return {
    color: seriesMetadata.color.Default,
    opacity: getOpacity(isCurrentHighlighted),
  };
};
